import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-share-detail-content",
  templateUrl: "./share-detail-content.component.html",
  styleUrls: ["./share-detail-content.component.css"],
})
export class ShareDetailContentComponent implements OnInit {
  appConstant: any;
  constructor(
    public dialogRef: MatDialogRef<ShareDetailContentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.appConstant = environment;
  }
  close() {
    this.dialogRef.close();
  }
  onBlurEvent(){
    this.dialogRef.close();

  }
}
